import { inject, Injectable } from '@angular/core';
import { Dictionary } from '@ngrx/entity';

import { CanvasElementType } from '@blaze-runtime/engine-domain';

import { ElementDefinitionsService } from '../../element-definitions.service';

/**
 * Decides which of a form's children feed its output. Only elements that report a change
 * (or a row selection) can carry a value into the form, so the others are skipped when the
 * form collects what its fields hold.
 */
@Injectable({ providedIn: 'root' })
export class FormChildOutputService {
  private readonly elementDefinitions = inject(ElementDefinitionsService);

  // why: cached because it is asked once per child update, and the answer is per type
  private readonly contributesByType: Dictionary<boolean> = {};

  /** Whether a child of this type should update the form's output when it emits. */
  contributesToFormOutput(elementType: CanvasElementType | undefined): boolean | undefined {
    if (!elementType) {
      return false;
    }

    if (this.contributesByType[elementType] === undefined) {
      const elementOutputs = this.elementDefinitions.getDefinition(elementType)?.ioConfig?.outputs;
      this.contributesByType[elementType] = !!elementOutputs?.find(
        ({ eventType }) => eventType === 'change' || eventType === 'row-select',
      );
    }

    return this.contributesByType[elementType];
  }
}
